module.exports = __webpack_public_path__ + "img/protect.9a01f8dd.svg";